<template>
    <li class="nav-item dropdown">
        <a id="navbarDropdownCart" href="#" class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            {{ t.cart.cart }} <i class="fas fa-shopping-bag fa-fw"></i>
            <span class="badge rounded-pill border bg-light text-dark">{{ cart.total_qty }}</span>
        </a>
        <ul id="cart" class="dropdown-menu dropdown-menu-end py-0 m-0" aria-labelledby="navbarDropdownCart">
            <div class="px-2 p-3">
                <div v-if="loaded && !cart.products.length" class="text-end fst-italic">
                    {{ t.cart.empty_cart }}
                </div>
                <div v-else-if="loaded">
                    <transition-group name="fade">
                        <div class="row m-0 mb-3" v-for="product in cart.products" :key="product.id">
                            <div class="col-4">
                                <a :href="product.url">
                                    <img :src="product.thumbnail" alt="" class="img-fluid">
                                </a>
                            </div>
                            <div class="col p-0 d-flex align-items-center">
                                <div>
                                    <div class="h5 mb-2"><a :href="product.url">{{product.name}}</a></div>
                                    <div class="mb-2" v-if="product.product_variation_attributes">
                                        <div v-for="(prod_var_attr, index) in product.product_variation_attributes" :key="index"><span class="h6">{{prod_var_attr.attribute.name}}</span>: {{prod_var_attr.value.name}}</div>
                                    </div>
                                    <div v-else v-html="truncateText(product.description, 20)" class="mb-2"></div>
                                    <div class="mb-3">{{product.qty}} x {{amountWithCurrency(product.price)}}</div>
                                    <div class="h5">{{ amountWithCurrency(product.total) }}</div>
                                    <!-- <div class="row align-items-center">
                                        <div class="col-7">
                                            <div class="input-group">
                                                <span class="input-group-prepend"><button @click="product.qty--; updateProduct(product)" :disabled="loading" type="button" class="btn btn-light border">-</button></span>
                                                <input type="text"  @focus="$event.target.select()" class="form-control text-center" :disabled="loading" v-model.number="product.qty" @change="updateProduct(product)">
                                                <span class="input-group-prepend"><button @click="product.qty++; updateProduct(product)" :disabled="loading" type="button" class="btn btn-light border">+</button></span>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="fw-bold">{{ amountWithCurrency(product.total) }}</div>
                                        </div>
                                    </div> -->
                                    <div v-if="product.is_gift" class="text-muted">(+{{amountWithCurrency(settings.gift_price*product.qty)}} {{ t.cart.gift_cost }})</div>
                                </div>
                            </div>
                            <div class="col-1 align-self-center text-center text-muted"><i class="fas fa-times fa-lg cursor-pointer" @click="deleteProduct(product)"></i></div>
                        </div>
                    </transition-group>
                    <transition name="fade">
                        <div v-if="loaded" class="text-end border-top py-3 text-uppercase">
                            <span class="fw-bold me-2">{{ t.cart.total }}</span><span class="h4">{{amountWithCurrency(cart.subtotal)}}</span>
                        </div>
                    </transition>
                </div>
            </div>
            <transition name="fade">
                <div v-if="loaded && cart.products.length" class="d-flex border-top">
                    <a :href="url('cart')" class="btn btn-light col">{{ t.checkout.edit_cart }}</a>
                    <a :href="url('checkout')" class="btn btn-primary col">{{ t.cart.checkout }}</a>
                </div>
            </transition>
        </ul>
    </li>
</template>

<script>
import store from '../CartStore'
    export default {
        store: store,
        data() {
            return {
                settings: settings,
                config: config,
                locale: locale,
                t: t,
            }
        },
        mounted() {
            this.$store.dispatch('getCart')
        },
        computed: {
            ...Vuex.mapGetters(['loaded', 'loading', 'cart']),
        },
        methods: {
            ...Vuex.mapActions(['deleteProduct', 'updateProduct']),
        }
    }
</script>
